import script from "./CheckoutSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutSummary.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutSummary.vue?vue&type=style&index=0&id=1b65f264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b65f264"]])

export default __exports__